import { MAPBOX_STYLE } from '../../helpers/mapbox-constants';
import isWebGLAvailable from '../../lib/webgl/detect';
import Component from '../component';

export default class MapShowComponent extends Component {
  constructor(...args) {
    super(...args);
    this._dom();
    this._init();
  }

  _dom() {
    this.dom.map = this.dom.component.querySelector('.map-show');
  }

  _init() {
    if (this.dom.map) {
      if (isWebGLAvailable()) {
        this._createMapObserver();
      } else {
        this._displayMapFallback();
      }
    }
  }

  _createMapObserver() {
    const observer = new IntersectionObserver((changes) => {
      changes.forEach((change) => {
        if (change.isIntersecting === true) {
          observer.unobserve(change.target);
          import('../../helpers/mapbox-loader').then(({ default: mapboxgl }) => {
            this._initMap(mapboxgl);
          });
        }
      });
    });
    observer.observe(document.querySelector('.card-show-wrapper'));
  }

  _initMap(mapboxgl) {
    const _params = {
      lat: this.dom.map.getAttribute('data-lat'),
      lng: this.dom.map.getAttribute('data-lng'),
    };

    this._Map = new mapboxgl.Map({
      container: this.dom.map,
      center: [_params.lng, _params.lat],
      zoom: 13,
      style: MAPBOX_STYLE,
    });
    this._Map.addControl(new mapboxgl.NavigationControl(), 'bottom-left');
    this._Map.scrollZoom.disable();

    const metersToPixelsAtMaxZoom = (meters, latitude) => meters / 0.075 / Math.cos((latitude * Math.PI) / 180);

    this._Map.on('load', () => {
      this._Map.addSource('source_circle_500', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: [_params.lng, _params.lat],
              },
            },
          ],
        },
      });
      this._Map.addLayer({
        id: 'circle500',
        type: 'circle',
        source: 'source_circle_500',
        paint: {
          'circle-radius': {
            stops: [[0, 0], [20, metersToPixelsAtMaxZoom(500, _params.lat)]],
            base: 2,
          },
          'circle-color': '#29AB87',
          'circle-opacity': 0.35,
        },
      });
    });
  }

  _displayMapFallback() {
    this.dom.map.classList.add('fallback');
    this.dom.map.innerHTML =
        '<div class="fallback-container"><p>Votre navigateur ne supporte pas l\'affichage de la carte.</p></div>';
  }
}
